"use strict";

var delay = require("../Strict/delay.js");

var mapL = require("./mapL.js");

var rangeL = require("./rangeL.js");

module.exports = intervalL;

function intervalL(time) {
  return mapL(delay(time), rangeL(Infinity));
}